export default __webpack_public_path__ + "static/media/SF-Pro-Display-Bold.170e68ac.otf";